import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IPortalPageSectionItem } from 'models/portal/page/portalpagesectionitem';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { browserHistory } from 'react-router';
import { CardItemProfileName, CardItemBadge } from 'components';
import { getProfileTabUrl, imgSrcAttributes, thumbUrl } from 'helpers/common';
require('./style.css');

export interface IProps {
	sectionItem: IPortalPageSectionItem;
	t?: (key: string, options?: any) => string;
	isDragging?: boolean;
	isFollowing?: boolean;
	followItem?: () => void;
	unfollowItem?: () => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewSectionItemProfile extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onViewProfileClick = this.onViewProfileClick.bind(this);
	}

	private onViewProfileClick(e: React.SyntheticEvent) {
		e.preventDefault();
		if (!this.props.isDragging) {
			browserHistory.push(
				`/profile/${(this.props.sectionItem.elements[4] as ISectionTextElement).text}${getProfileTabUrl('default')}`,
			);
		}
	}

	public render() {
		const { followItem, isFollowing, unfollowItem, t } = this.props;
		const { elements } = this.props.sectionItem;
		const badge = elements[7] && (elements[7] as ISectionTextElement).text;
		const onClick = (e) => this.onViewProfileClick(e);
		let profilePicture = (elements[0] as ISectionImageElement).imageUrl;
		if (!profilePicture) {
			profilePicture = require('containers/Html/images/defaultUser.svg');
		}
		const followers = Number((elements[5] as ISectionTextElement).text);
		const profileNameProps = {
			name: (elements[1] as ISectionTextElement).text,
			onClick,
			onFollow: followItem,
			onUnfollow: unfollowItem,
			isFollowing,
		};
		let imagePart = (
			<figure className="profileImage imageHolder" style={{ backgroundImage: `url(${thumbUrl(profilePicture)})` }}>
				<img onClick={onClick} {...imgSrcAttributes(profilePicture)} />
			</figure>
		);
		if (badge) {
			imagePart = (
				<div className="userItemCardImage">
					<CardItemBadge text={badge} variant="orange" size="S" />
					{imagePart}
				</div>
			);
		}
		return (
			<div className="userItemCard commonItemCard" onClick={onClick}>
				<CardItemProfileName {...profileNameProps} />
				{imagePart}
				<div className="itemDetail">
					<div className="byName">{profileNameProps.name}</div>
					<div className="byName">&nbsp;</div>
					{isNaN(followers) ? null : <div className="likes">{followers + ' ' + t('BSPortal_Common_Followers')}</div>}
				</div>
			</div>
		);
	}
}

export { ViewSectionItemProfile };
